import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'underscore';
import { toggleLead } from '../../actions/UserProfileActions';
import {
    fetchAllPersons,
    queryChanged,
    filterChanged,
    loadingChanged,
    fetchMorePersons,
    toggleMenuChanged,
    toggleMobileMenuChanged,
    filterClearAll
} from '../../actions/CommunityActions';
import CommunityListView from './CommunityListView';
import CommunitySidebarView from './CommunitySidebarView';
import { getInternalWebsiteBaseUrlSelector } from '../../selectors/EventSelectors';

function mapStateToProps(state) {
    const {communityPageReducer, queryReducer, personsReducer, meReducer, eventReducer, siteConfReducer} = state;
    return {
        groupModalOpen: communityPageReducer.groupModalOpen,
        toggleMobileMenu: communityPageReducer.toggleMobileMenu,
        isLoading: communityPageReducer.isLoading,
        event: eventReducer.event,
        search: queryReducer.search,
        attributeSelected: queryReducer.attributeSelected,
        persons: personsReducer.persons,
        facets: personsReducer.facets,
        isLinkedInTokenValid: meReducer.isLinkedInTokenValid,
        me: meReducer.me,
        siteConf: siteConfReducer.siteConf,
        baseUrl: getInternalWebsiteBaseUrlSelector(state)
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchAllPersons,
        queryChanged,
        filterChanged,
        toggleMenuChanged,
        toggleMobileMenuChanged,
        loadingChanged,
        fetchMorePersons,
        toggleLead,
        filterClearAll
    }, dispatch);
}

class CommunityView extends Component {

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    hasNextPage() {
        const total = this.props.search.total || 0;
        const offset = this.props.search.offset || 0;
        const count = this.props.search.count;
        return (offset + count < total);
    }

    getNewOffset() {
        let newOffset = this.props.search.offset;
        if (this.hasNextPage()) {
            const offset = this.props.search.offset || 0;
            const count = this.props.search.count;
            newOffset = offset + count;
        }
        return newOffset;
    }

    fetchAllPersons() {
        this.props.fetchAllPersons({
            eventId: this.props.event.id
        });
    }

    fetchMorePersons = () => {
        if (!this.hasNextPage()) {
            return;
        }

        const offset = this.getNewOffset();
        const search = Object.assign({}, this.props.search, {
            offset: offset
        });

        this.props.fetchMorePersons({
            eventId: this.props.event.id,
            search: search
        });
    }

    handleChange = (data = {}) => {
        data.offset = 0;
        if (data.groupSelected) {
            this.props.filterChanged(data);
        } else {
            this.props.queryChanged(data);
        }
        this.fetchAllPersons();
    }

    handleFilterClearAll = () => {
        this.props.filterClearAll();
        this.fetchAllPersons();
    }

    handleScroll = _.debounce(() =>{
        var doc = document.documentElement;
        var windowTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        var offsetFromBottom = 500;
        if (windowTop + window.innerHeight >= document.body.clientHeight - offsetFromBottom) {
            this.fetchMorePersons();
        }
    }, 1000)


    render() {
        return (
            <div>
                <header className="community-menu"/>
                <CommunitySidebarView handleChange={this.handleChange}
                    search={this.props.search}
                    facets={this.props.facets}
                    attributeSelected={this.props.attributeSelected}
                    toggleMenuChanged={this.props.toggleMenuChanged}
                    groupModalOpen={this.props.groupModalOpen}
                    toggleMobileMenuChanged={this.props.toggleMobileMenuChanged}
                    toggleMobileMenu={this.props.toggleMobileMenu}
                    handleClearAll={this.handleFilterClearAll}/>
                <div className="main-community-container container-fluid">
                    <CommunityListView persons={this.props.persons}
                        event={this.props.event}
                        baseUrl={this.props.baseUrl}
                        isLinkedInTokenValid={this.props.isLinkedInTokenValid}
                        toggleLead={this.props.toggleLead}
                        search={this.props.search}
                        me={this.props.me}
                        siteConf={this.props.siteConf}
                        isLoading={this.props.isLoading}
                        fetchMorePersons={this.fetchMorePersons}
                        hasNextPage={this.hasNextPage.bind(this)}/>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CommunityView);
